import { render, staticRenderFns } from "./editBox.vue?vue&type=template&id=668f95fe&scoped=true&"
import script from "./editBox.vue?vue&type=script&lang=js&"
export * from "./editBox.vue?vue&type=script&lang=js&"
import style0 from "./editBox.vue?vue&type=style&index=0&id=668f95fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668f95fe",
  null
  
)

export default component.exports